import { Button } from '@mui/material';
import React from 'react';

const ReRequestWaiverConfirmation = (props: any) => {
    const { onConfirm, onClose, isLoading } = props;
    return (
        <div className="modal-overlay" style={{ padding: "1rem 1.5rem" }}>
            <div className="modal">
                <h2 className="modal-title">Active Price Exception Exists</h2>
                <p className="modal-message">
	                You already have an active price exception. Submitting new values will update that request — its current values will be kept in the exception's history.
                </p>
                <div className="modal-actions" style={{ display: "flex", justifyContent: "space-between" }}>
                    <Button
                        className="btn-primary"
                        color="primary"
                        variant="contained"
                        disabled={isLoading}
                        onClick={onConfirm}>
                        Update Request
                    </Button>
                    <Button
                        color="primary"
                        variant="outlined"
                        disabled={isLoading}
                        onClick={onClose}>
                        Cancel
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default ReRequestWaiverConfirmation;
